import React, { Component } from 'react'
import DateFnsUtils from '@date-io/date-fns'
import { MuiPickersUtilsProvider, MuiKeyboardTimePicker, MuiGrid } from '../../../ui'


class TimeComponent extends Component {
    constructor(props) {
        super(props)
    }
    render() {
        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <MuiGrid contianer style={{ padding: "8px" }}>
                    <MuiKeyboardTimePicker
                        id={this.props.label}
                        //label={this.props.label}
                        value={this.props.value}
                        InputProps={{
                            disableUnderline: true,
                        }}
                        onChange={(date) => this.props.handleTimeChange(date, this.props.label)} />
                </MuiGrid>
            </MuiPickersUtilsProvider>
        )
    }
}
export default TimeComponent